import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DeviceTable from "components/deviceTable";
import RateTable from "components/rateTable";
import { setRateTable } from "store/slices/firebaseSlice";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { db } from "services/firebase";

function RateTableLayout() {
  const dispatch = useDispatch();
  const { clientId, rateTableData, deviceIds } = useSelector((state) => state.firebase);
  const [selectedDevice, setSelectedDevice] = useState(null);

  useEffect(() => {
    if (!clientId || !selectedDevice) return;

    const getRateTableData = async () => {
      const rateTable = await getDocs(
        collection(db, "Results", clientId, "devices", selectedDevice, "rate")
      );
      let data = [];
      for (const num of rateTable.docs) {
        const result = num.data();
        result.id = num.id;
        if (result.date && result.date.toDate) {
          result.date = result.date.toDate().toLocaleString();
        }
        data = [...data, result];
      }
      dispatch(setRateTable(data));
    };
    getRateTableData();
  }, [selectedDevice]);

  const handleDataUpdate = async (updatedData, recordId) => {
    try {
      if (!clientId || !selectedDevice || !recordId) return;

      // Update the document in Firebase
      const docRef = doc(db, "Results", clientId, "devices", selectedDevice, "rate", recordId);
      await updateDoc(docRef, updatedData);

      // Refresh the local data
      const rateTable = await getDocs(
        collection(db, "Results", clientId, "devices", selectedDevice, "rate")
      );
      let data = [];
      for (const num of rateTable.docs) {
        const result = num.data();
        result.id = num.id;
        if (result.date && result.date.toDate) {
          result.date = result.date.toDate().toLocaleString();
        }
        data = [...data, result];
      }
      dispatch(setRateTable(data));

      console.log("Rate table data updated successfully");
    } catch (error) {
      console.error("Error updating rate table data:", error);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={2.4}>
            <DeviceTable
              clientId={clientId}
              deviceIds={deviceIds}
              selectedDevice={selectedDevice}
              onDeviceSelect={setSelectedDevice}
            />
          </Grid>

          {selectedDevice && (
            <Grid item xs={12} md={9}>
              <RateTable
                selectedDevice={selectedDevice}
                rateTableData={rateTableData}
                onDataUpdate={handleDataUpdate}
              />
            </Grid>
          )}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default RateTableLayout;
